import { render, staticRenderFns } from "./RouteToBlock.vue?vue&type=template&id=a98160cc&scoped=true&"
import script from "./RouteToBlock.vue?vue&type=script&setup=true&lang=js&"
export * from "./RouteToBlock.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98160cc",
  null
  
)

export default component.exports